import { useQuery } from '@tanstack/react-query';
import { Country } from 'App/i18n/enums';
import { Plan } from 'commons/services/configurationService';
import getPlans from 'commons/services/plans/plansService';

interface useGetPlansProps {
  regionalPaymentGatewayId: Country;
  custom: boolean;
  active: boolean;
}

const useGetPlans = (props: useGetPlansProps) => {
  const { regionalPaymentGatewayId, custom, active } = props;

  const { data, isLoading, error } = useQuery<Plan[]>({
    queryKey: ['plans', regionalPaymentGatewayId, custom, active],
    queryFn: () => getPlans(regionalPaymentGatewayId, custom, active),
  });

  return { data, isLoading, error };
};

export default useGetPlans;
